module.exports = __webpack_public_path__ + "img/gill1.d4232e47.svg";